import React from "react";
import Icon from "./Icon";

export const LightningIcon = () => (
  <Icon>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 3V12C7 12.55 7.45 13 8 13H10V20.15C10 20.66 10.67 20.84 10.93 20.4L16.12 11.5C16.51 10.83 16.03 10 15.26 10H13L15.49 3.35C15.74 2.7 15.26 2 14.56 2H8C7.45 2 7 2.45 7 3Z" fill="#23410A"/>
  </Icon>
);
